var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import AccordionSummary, { accordionSummaryClasses } from '@mui/material/AccordionSummary';
import { styled } from '../styled';
import { ChevronDownIcon } from '../icon';
var ExpansionPanelSummaryComponentName = 'QuantumExpansionPanelSummary';
export var ExpansionPanelSummary = styled(AccordionSummary, {
    name: ExpansionPanelSummaryComponentName,
    slot: 'Root',
})(function (_a) {
    var _b, _c;
    var theme = _a.theme;
    return (_b = {
            padding: 0,
            minHeight: 'unset',
            borderRadius: 4
        },
        _b["&.".concat(accordionSummaryClasses.expanded)] = {
            minHeight: 'unset',
        },
        _b["& .".concat(accordionSummaryClasses.expandIconWrapper)] = {
            fontSize: theme.typography.pxToRem(16),
            color: theme.tokens.color_fg_default,
        },
        _b["& .".concat(accordionSummaryClasses.content)] = (_c = {
                margin: 0
            },
            _c["&.".concat(accordionSummaryClasses.expanded)] = {
                margin: 0,
            },
            _c),
        _b['&:focus-visible'] = __assign({}, theme.mixins.focusRing()),
        _b["&.".concat(accordionSummaryClasses.focusVisible)] = {
            backgroundColor: 'transparent',
        },
        _b);
});
ExpansionPanelSummary.defaultProps = {
    expandIcon: React.createElement(ChevronDownIcon, null),
};
